<template>
  <b-table
    responsive
    striped
    bordered
    :fields="AVMFields"
    :items="AVMItems"
    :class="$style.avmTable"
    class="mb-0 fraudReportHeaderTable"
  >
    <template v-slot:thead-top="">
      <b-tr>
        <b-th  rowspan="3" :aria-sort="ariaSortSlno" class="text-right" @click="ariaSortM('slno','ariaSortSlno','ariaSortDist')">#</b-th>
        <b-th rowspan="3" :aria-sort="ariaSortDist" class="text-right" :class="$style.distWidth" @click="ariaSortM('dist','ariaSortDist','ariaSortSlno')"> Dist (Miles)</b-th>
        <b-th rowspan="3" :class="$style.addressWidth">Address</b-th>
        <b-th rowspan="3" class="text-right">Zip</b-th>
        <b-th rowspan="2" class="text-right">Beds</b-th>
        <b-th rowspan="2" class="text-right">Living</b-th>
        <b-th rowspan="3" class="text-right">Year Built</b-th>
        <b-th rowspan="2">Sold</b-th>
        <b-th rowspan="2">List</b-th>
        <b-th rowspan="3">Type</b-th>
        <b-th rowspan="1">REO</b-th>
        <b-th></b-th>
      </b-tr>
      <b-tr>
        <b-th>Foreclosure Code</b-th>
        <b-th>Source</b-th>
      </b-tr>
       <b-tr>
        <b-th class="text-right">Baths</b-th>
        <b-th class="text-right">Land</b-th>
        <b-th>Sold Date</b-th>
        <b-th>List Date</b-th>
        <b-th>Short Sale Code</b-th>
        <b-th>Status</b-th>
      </b-tr>
    </template>
        <template v-slot:cell(slno)="rowitem"
      >{{ rowitem.item.slno }}
    </template>
    <template v-slot:cell(dist)="rowitem"
      >{{ rowitem.item.dist }}
    </template>
    <template v-slot:cell(address)="rowitem"
      >{{ rowitem.item.address }}
    </template>
    <template v-slot:cell(zip)="rowitem"
      >{{ rowitem.item.zip }}
    </template>
    <template v-slot:cell(beds)="rowitem"
      ><div class="border-bottom">{{ rowitem.item.beds }}</div>
      <div>{{ rowitem.item.baths }}</div>
    </template>
    <template v-slot:cell(living)="rowitem"
      ><div class="border-bottom">{{ rowitem.item.living }}</div>
      <div>{{ rowitem.item.land }}</div>
    </template>
    <template v-slot:cell(yearbuilt)="rowitem"
      >{{ rowitem.item.yearbuilt }}
    </template>
    <template v-slot:cell(sold)="rowitem"
      ><div class="border-bottom">{{ rowitem.item.sold }}</div>
      <div>{{ rowitem.item.solddate }}</div>
    </template>
    <template v-slot:cell(list)="rowitem"
      ><div class="border-bottom">{{ rowitem.item.list }}</div>
      <div>{{ rowitem.item.listdate }}</div>
    </template>
    <template v-slot:cell(type)="rowitem"
      >{{ rowitem.item.type }}
    </template>
    <template v-slot:cell(reo)="rowitem"
      ><div class="border-bottom">{{ rowitem.item.reo }}</div>
      <div class="border-bottom">{{ rowitem.item.foreclosure }}</div>
      <div>{{ rowitem.item.shortsale }}</div>
    </template>
    <template v-slot:cell(source)="rowitem"
      ><div class="border-bottom">{{ rowitem.item.source }}</div>
      <div>{{ rowitem.item.status }}</div>
    </template>
  </b-table>
</template>

<script>
export default {
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data(){
  return{
    ariaSortSlno: "none",
    ariaSortDist:"none"
  }
},
  computed: {
    AVMFields() {
      return this.fields
    },
    AVMItems() {
      return this.items
    },
  },
  methods:{
    ariaSortM(param,sort,disablesort){
      if( this[sort]=== "none" ||  param === 'dist'&& this[sort]==="descending" ||  param === 'slno'&& this[sort]==="ascending"){
        this[sort]=param==='slno'? 'descending':'ascending'
        this[disablesort]="none"
        this.items=param==='slno'? this.items.sort((a, b) => b[param] - a[param]): this.items.sort((a, b) => a[param] - b[param])
      }else{
        this[sort]=param==='slno'? 'ascending':'descending'
        this[disablesort]="none"
        this.items=param==='slno'? this.items.sort((a, b) => a[param] - b[param]):this.items.sort((a, b) => b[param] - a[param])
    }
    }
  },
}
</script>

<style lang="scss" module>
@import '@design';
.avmTable {
  thead > tr:last-of-type {
    display: none;
  }
}
.addressWidth {
  width: 300px;
}
.distWidth {
  width: 50px;
}
</style>
